// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-dialog-public-relations-list {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
.dl-dialog-public-relations-list__main-title-text {
  margin-top: 24px;
  font-weight: 500;
  font-size: var(--g-text-body-2-font-size);
}
.dl-dialog-public-relations-list__group {
  margin-top: 8px;
}
.dl-dialog-public-relations-list__group-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.dl-dialog-public-relations-list__group-title-text {
  margin-right: 16px;
}
.dl-dialog-public-relations-list__right-section {
  flex-shrink: 0;
  margin-left: auto;
  margin-right: 4px;
  display: flex;
  align-items: center;
}
.dl-dialog-public-relations-list__alert {
  margin-right: 12px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/EntryDialogues/DialogSwitchPublic/DialogPublic/RelationsList/RelationsList.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,cAAA;AACJ;AACI;EACI,gBAAA;EACA,gBAAA;EACA,yCAAA;AACR;AAEI;EACI,eAAA;AAAR;AAGI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AADR;AAII;EACI,kBAAA;AAFR;AAKI;EACI,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AAHR;AAMI;EACI,kBAAA;AAJR","sourcesContent":[".dl-dialog-public-relations-list {\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n}\n.dl-dialog-public-relations-list__main-title-text {\n  margin-top: 24px;\n  font-weight: 500;\n  font-size: var(--g-text-body-2-font-size);\n}\n.dl-dialog-public-relations-list__group {\n  margin-top: 8px;\n}\n.dl-dialog-public-relations-list__group-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n.dl-dialog-public-relations-list__group-title-text {\n  margin-right: 16px;\n}\n.dl-dialog-public-relations-list__right-section {\n  flex-shrink: 0;\n  margin-left: auto;\n  margin-right: 4px;\n  display: flex;\n  align-items: center;\n}\n.dl-dialog-public-relations-list__alert {\n  margin-right: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
